import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { PublishableFragmentDoc } from '../../fragments/generated/Publishable';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type FetchIsPublishableQueryVariables = Types.Exact<{
  filters: Types.GetResourceByIdFilter;
}>;


export type FetchIsPublishableQuery = { content?: { id: string, allowMinorVersionPublish: boolean, publishable: { isPublishable: boolean, reason?: Types.ContentPublishFailureReasonEnum | null } } | { id: string, allowMinorVersionPublish: boolean, publishable: { isPublishable: boolean, reason?: Types.ContentPublishFailureReasonEnum | null } } | { id: string, allowMinorVersionPublish: boolean, publishable: { isPublishable: boolean, reason?: Types.ContentPublishFailureReasonEnum | null } } | { id: string, allowMinorVersionPublish: boolean, publishable: { isPublishable: boolean, reason?: Types.ContentPublishFailureReasonEnum | null } } | { id: string, allowMinorVersionPublish: boolean, publishable: { isPublishable: boolean, reason?: Types.ContentPublishFailureReasonEnum | null } } | { id: string, allowMinorVersionPublish: boolean, publishable: { isPublishable: boolean, reason?: Types.ContentPublishFailureReasonEnum | null } } | { id: string, allowMinorVersionPublish: boolean, publishable: { isPublishable: boolean, reason?: Types.ContentPublishFailureReasonEnum | null } } | { id: string, allowMinorVersionPublish: boolean, publishable: { isPublishable: boolean, reason?: Types.ContentPublishFailureReasonEnum | null } } | {} | null };


export const FetchIsPublishableDocument = /*#__PURE__*/ gql`
    query fetchIsPublishable($filters: GetResourceByIdFilter!) {
  content(filters: $filters) {
    ... on CourseContentType {
      id
      allowMinorVersionPublish
      publishable {
        ...Publishable
      }
    }
    ... on TaskContentType {
      id
      allowMinorVersionPublish
      publishable {
        ...Publishable
      }
    }
    ... on ScormContentType {
      id
      allowMinorVersionPublish
      publishable {
        ...Publishable
      }
    }
    ... on PathContentType {
      id
      allowMinorVersionPublish
      publishable {
        ...Publishable
      }
    }
    ... on ExternalContentType {
      id
      allowMinorVersionPublish
      publishable {
        ...Publishable
      }
    }
    ... on ArticleContentType {
      id
      allowMinorVersionPublish
      publishable {
        ...Publishable
      }
    }
    ... on QuizContentType {
      id
      allowMinorVersionPublish
      publishable {
        ...Publishable
      }
    }
    ... on SurveyContentType {
      id
      allowMinorVersionPublish
      publishable {
        ...Publishable
      }
    }
  }
}
    ${PublishableFragmentDoc}`;

export function useFetchIsPublishableQuery(options: Omit<Urql.UseQueryArgs<FetchIsPublishableQueryVariables>, 'query'>) {
  return Urql.useQuery<FetchIsPublishableQuery, FetchIsPublishableQueryVariables>({ query: FetchIsPublishableDocument, ...options });
};